module.exports = "//static.hsappstatic.net/LoginUI/static-1.14728/img/SUI_mobile.svg"